import React from 'react';

import { createIcon } from '../createIcon';

function SvgArrowDown(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="M2 2h12v12H2z" />
        <path
          d="M6.808 10.17v-.136V3.21c0-.52.27-.949.744-1.13a1.175 1.175 0 011.6 1.085V10.147l.09-.09 2.75-2.689c.473-.452 1.15-.474 1.623-.068.473.43.518 1.153.09 1.605-.406.406-.811.79-1.217 1.197-1.217 1.175-2.412 2.35-3.629 3.525-.518.497-1.217.497-1.735 0-1.578-1.536-3.155-3.095-4.733-4.632a1.262 1.262 0 01-.383-.723c-.068-.588.315-1.152.901-1.265.428-.068.79.045 1.082.338l2.75 2.69c0 .067.022.09.067.135z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export const ArrowDownFilledIcon = createIcon(SvgArrowDown, 'ArrowDownFilledIcon');
